import type { IconSvgObject } from './types';

const ArrowDown02Icon: IconSvgObject = [
  ["path", { d: "M18 13L12 19L6 13M12 18.5V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowDown02Icon;
